import { Card, CardHeader, Grid } from "@mui/material";
import React from "react";
import ChatBoardReply from "./ChatBoardReply";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";



const InboxReplyChatBoard = ({}) => {
    const { authority, plan, form, year, serial, formType, id: urlId } = useParams(); //:authority/:plan/:form/:year/:serial
  console.log(useParams(), "paramsHook");
  const id = urlId ? urlId : `${authority}/${plan}/${form}/${year}/${serial}`;
  console.log("loggingIdFromComp", id, urlId);
  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
    const history = useHistory();
    const stateId = Digit.ULBService.getStateId();
   const isEmployee = history.location.pathname.includes("employee");
    const { data = {}, isLoading } = Digit.Hooks.obps.useBPADetailsPage(stateId, { applicationNo: id, isEmployee, formType }, { formType });
    const { collectionBillRes, collectionBillDetails } = data;
    const appData = data?.LandUse?.[0] || data?.ownerRegistration?.[0] || data?.PurchasableFAR?.[0] || data?.BPA?.[0];
    console.log("appDetail", data, appData);
    let search = window.location.search;
    const messageId = search.split("=")[1];
    console.log("messageId  ", messageId);
    console.log("appadat ", appData);
  return <div>
    <ChatBoardReply formData={appData} messageId={messageId}/>
  </div>;
}

export default InboxReplyChatBoard;